import { Box } from '@material-ui/core';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { launch } from 'shared/helper/serviceLauncher';
import { makeStyles } from '@material-ui/core/styles';
import { MSG_AGENDAR_ATENDIMENTO_PRESENCIAL, MSG_DOCUMENTO_BAIXADO_SUCESSO } from 'shared/constantes/mensagens';
import { platform } from 'platformImpl';
import { TK_TIPOS_ACAO_SELECAO_SERVICO, trackServiceSelectORA } from 'shared/helper/tracker';
import AppFooter from './AppFooter';
import Avaliacao from '../../apps/avaliacao/Avaliacao';
import DadosDivergentes from './DadosDivergentes';
import lockImg from '../../assets/img/key.webp';
import maintenanceIcon from '../../assets/img/tela-manutencao.svg';
import telaAtencao from '../../assets/img/ilustracao-atencao.svg';
import telaErro from '../../assets/img/ilustracao-erro.svg';
import telaExclamacao from '../../assets/img/ilustracao-exclamacao.svg';
import telaIndisponivel from '../../assets/img/tela-indisponibilidade.svg';
import telaSucesso from '../../assets/img/ilustracao-sucesso.svg';
import telaTimeOut from '../../assets/img/ilustracao-indisponibilidade.webp';
import workinprogress from '../../assets/img/manutencao.svg';
import ilustracaoManutencao from '../../assets/img/ilustracao-manutencao.webp';
import ilustracaoServicoNaoAutorizado from '../../assets/img/ilustracao-servico-bloq.webp';
import DadosDaInscricaoINSS from './DadosDaInscricaoINSS';

const TEXTO_PORTAL = `Acesse o <a href="https://www.gov.br/inss/pt-br/servicos" target="_blank" style="font-size: inherit">Portal do INSS</a> ou ligue 135.`;

/**
 * InfoScreen
 * 
 * @param {Object} props 
 * @param {string} props.icon 
 * @param {string} props.primaryText 
 * @param {string} props.secondaryText 
 * @param {string} props.link 
 * @param {string} props.tipo 
 * @param {Array} props.data 
 * @param {string} props.servico 
 * @param {string} props.descricao 
 * @param {string} props.buttonText Usado nos botões do AppFooter
 * @param {Function} props.action Usado nos botões do AppFooter
 * @param {string} props.buttonSecondaryText Usado nos botões do AppFooter
 * @param {Function} props.secondaryAction Usado nos botões do AppFooter
 * @param {boolean} props.actionDisabled Usado nos botões do AppFooter
 * @param {string} props.primaryTextBtn Usado quando o tipo for DadosDivergentes
 * @param {Function} props.primaryActionBtn Usado quando o tipo for DadosDivergentes
 * @param {string} props.secondaryTextBtn Usado quando o tipo for DadosDivergentes
 * @param {Function} props.secondaryActionBtn Usado quando o tipo for DadosDivergentes
 * @returns {JSX.Element}
 */
export default function InfoScreen(props) {

  const classes = useStyles();  
  return (
    <>
    {
      props.messageError !== 'erro_procurador_atualizacao' &&
      <div className={`${classes.container} info-screen`}>
        <div className={classes.infoContainer}>
          <div className={classes.item}>
            {props.icon && (
              <img src={props.icon} className={classes.img} alt={'InfoScreen'} />
            )}
          </div>

          <div className={`${classes.item} ${classes.itemContent}`}>
            <div>
              {props.primaryText && (
                <p className={classes.primaryTextLateral} dangerouslySetInnerHTML={{ __html: props.primaryText }}></p>
              )}
            </div>
            <div>
              {props.secondaryText && (
                <p className={classes.secondaryTextLateral} dangerouslySetInnerHTML={{ __html: props.secondaryText }}></p>
              )}
            </div>
          </div>
          {
            props.link ? (
              platform.isCordova ?
                <label className={classes.secondaryText} onClick={() => window.open(props.link, "_system")}>{props.link}</label>
                :
                <a href={props.link} target="_blank" className={classes.secondaryText}>{props.link}</a>
            ) : null
          }
        </div>
      </div>
     }
      <>
        {
          props.tipo === 'DadosDivergentes' && props.data &&
          <DadosDivergentes data={props.data} />
        }
        {
          props.tipo === 'DadosDaInscricaoINSS' && props.data &&
          <DadosDaInscricaoINSS data={props.data} dados={props.dados}/>
        }
      </>
      <Box p={2} />
      <div className={classes.containerFooter}>
        {props.servico &&
          <Avaliacao
            servico={props.servico}
            descricao={props.descricao}
          />
        }

        {props.buttonText && props.action && (
          <div className={classes.AppFooter}>
            <AppFooter
              primaryText={props.buttonText}
              primaryAction={() => props.action()}
              secondaryText={props.buttonSecondaryText ? props.buttonSecondaryText : null}
              secondaryAction={props.secondaryAction ? () => props.secondaryAction() : null}
              primaryDisabled={props.actionDisabled}
              textAlign="center"
            />
          </div>
        )}

      </div>
      {
        props.tipo === 'DadosDivergentes' && props.data && props.messageError !== 'erro_procurador_atualizacao' &&
        <div className={classes.containerFooterDivergente}>
          <div className={classes.AppFooter}>
            {props.primaryTextBtn &&
              props.primaryActionBtn && (
                <AppFooter                  
                  primaryText={props.primaryTextBtn}
                  primaryAction={() => props.primaryActionBtn()}
                  secondaryText={props.secondaryTextBtn}
                  secondaryAction={() => props.secondaryActionBtn()}
                  tertiaryText={props.tertiaryText}
                  tertiaryAction={() => props.tertiaryAction()}
                  textAlign="center"
                />
              )}
          </div>
        </div>
      }      
    </>
  )

}

/**
 * NoContent
 * 
 * @param {Object} props 
 * @param {string} props.primaryText 
 * @param {string} props.secondaryText 
 * @param {string} props.servico 
 * @param {string} props.descricao 
 * @param {string} props.buttonText Usado nos botões do AppFooter
 * @param {Function} props.action Usado nos botões do AppFooter
 * @param {boolean} props.actionDisabled Usado nos botões do AppFooter
 * @returns {JSX.Element}
 */
export function NoContent(props) {
  return <InfoScreen icon={props.icon ? props.icon : telaExclamacao}
    action={props.action} buttonText={props.buttonText} actionDisabled={props.actionDisabled}
    primaryText={props.primaryText} secondaryText={props.secondaryText}
    servico={props.servico} descricao={props.descricao} />
}

export function NoContentWithSecondary(props) {
  return <InfoScreen icon={telaExclamacao}
    action={props.action} buttonText={props.buttonText} actionDisabled={props.actionDisabled}
    secondaryAction={props.secondaryAction} buttonSecondaryText={props.buttonSecondaryText}
    primaryText={props.primaryText}
    secondaryText={props.secondaryText}
    servico={props.servico}
    descricao={props.descricao} />
}

export function NoContentWithoutIcon(props) {
  return <InfoScreen action={props.action} buttonText={props.buttonText} actionDisabled={props.actionDisabled}
    primaryText={props.primaryText} secondaryText={props.secondaryText} />
}

export function WorkInProgress(props) {
  return <InfoScreen icon={workinprogress}
    action={props.action} buttonText={props.buttonText} actionDisabled={props.actionDisabled}
    primaryText={props.primaryText} secondaryText={props.secondaryText} />
}

/**
 * ErrorScreen
 * 
 * @param {Object} props 
 * @param {string} props.primaryText 
 * @param {string} props.secondaryText 
 * @param {string} props.servico 
 * @param {string} props.link 
 * @param {string} props.descricao 
 * @param {string} props.buttonText Usado nos botões do AppFooter
 * @param {Function} props.action Usado nos botões do AppFooter
 * @returns {JSX.Element}
 */
export function ErrorScreen(props) {
  return <InfoScreen icon={telaErro}
    action={props.action} buttonText={props.buttonText}
    primaryText={props.primaryText} secondaryText={props.secondaryText} link={props.link}
    secondaryAction={props.secondaryAction} buttonSecondaryText={props.buttonSecondaryText}
    servico={props.servico} descricao={props.descricao} />
}

export function TimeOutScreen(props) {
  return <InfoScreen 
    icon={telaTimeOut}
    action={props.action} buttonText={props.buttonText}
    secondaryAction={props.secondaryAction} buttonSecondaryText={props.buttonSecondaryText}
    primaryText={props.primaryText} secondaryText={props.secondaryText || TEXTO_PORTAL} 
    link={props.link}
    servico={props.servico} descricao={props.descricao} />

}
export function UnavailableScreen(props) {
  return <InfoScreen icon={telaIndisponivel}
    action={props.action} buttonText={props.buttonText}
    primaryText={props.primaryText} secondaryText={props.secondaryText} link={props.link}
    servico={props.servico} descricao={props.descricao} />
}

export function AlertScreen(props) {
  return (
    <InfoScreen
      icon={telaAtencao}
      action={props.action}
      buttonText={props.buttonText}
      actionDisabled={props.actionDisabled}
      secondaryAction={props.secondaryAction}
      buttonSecondaryText={props.buttonSecondaryText}
      primaryText={props.primaryText}
      secondaryText={props.secondaryText}
      servico={props.servico}
      descricao={props.descricao}
    />
  )
}

export function SuccessScreen(props) {
  return <InfoScreen icon={telaSucesso}
    action={props.action} buttonText={props.buttonText}
    primaryText={props.primaryText} secondaryText={props.secondaryText}
    servico={props.servico} descricao={props.descricao} />
}

export function ServiceDeniedScreen(props) {
  return <InfoScreen icon={ilustracaoServicoNaoAutorizado}
    action={props.action} buttonText={props.buttonText}
    buttonSecondaryText={props.buttonSecondaryText}
    primaryText={props.primaryText} secondaryText={props.secondaryText} secondaryAction={props.secondaryAction}
    servico={props.servico} descricao={props.descricao} />
}

export function IconScreen(props) {
  return <InfoScreen icon={props.icon}
    action={props.action} buttonText={props.buttonText} actionDisabled={props.actionDisabled}
    primaryText={props.primaryText} secondaryText={props.secondaryText} />
}

export function LoginScreen(props) {
  return <InfoScreen icon={lockImg}
    action={props.action} buttonText={props.buttonText}
    primaryText={props.primaryText} secondaryText={props.secondaryText} />
}

export function MaintenanceScreen(props) {
  return <InfoScreen icon={maintenanceIcon}
    action={props.action} buttonText={props.buttonText}
    primaryText={props.primaryText} secondaryText={props.secondaryText} />
}

export function ServicoNaoHabilitadoScreen(props) {
  return <InfoScreen icon={telaAtencao}
    action={props.action} buttonText={props.buttonText}
    primaryText={"Não é possível pedir esse serviço pelo Meu INSS."}
    secondaryText={"Ligue para o número 135 para pedir ou para mais informações."} />
}

export function ManutencaoMeuInssScreen(props) {
  return <InfoScreen icon={ilustracaoManutencao}
    action={props.action} buttonText={props.buttonText}
    primaryText={props.primaryText} secondaryText={props.secondaryText} />
}

export function DadosDivergenteScreen(props) {
  return (
    <InfoScreen
      icon={telaErro}      
      primaryDisabledBtn={props.primaryDisabledBtn}
      primaryActionBtn={props.primaryActionBtn}
      primaryTextBtn={props.primaryTextBtn}
      primaryText={props.primaryText}
      secondaryText={props.secondaryText}
      tertiaryAction={props.tertiaryAction}
      tertiaryText={props.tertiaryText}
      link={props.link}
      servico={props.servico}
      descricao={props.descricao}
      tipo={props.tipo}
      data={props.data}      
      messageError={props.messageError}
    />
  )
}

export function DadosDaInscricaoINSSScreen(props) {
  return (
    <InfoScreen
      icon={telaSucesso}            
      action={() => props.action()}
      buttonText={props.buttonText}
      secondaryAction={props.secondaryAction}
      buttonSecondaryText={props.buttonSecondaryText}
      primaryText={props.primaryText}      
      tipo={props.tipo}
      data={props.data}      
      dados={props.dados}
    />
  )
}

const DownloadSuccessScreen_ = (props) => {

  const { action, buttonText, servico, descricao, blankMessage } = props;

  useEffect(() => {
    if (props.menuItems) {
      let linkAgendamentoElem = document.getElementById("link-agendamento-servico");
      if (linkAgendamentoElem) {
        linkAgendamentoElem.removeEventListener("click", redirectNovoPedido);
        linkAgendamentoElem.addEventListener("click", redirectNovoPedido);
      }
    }
  }, [props.menuItems])

  const redirectNovoPedido = (e) => {
    e.preventDefault();
    let item = {
      sagService: props.descricao,
      sigla: props.siglaServico
    }
    if (item) {
      trackServiceSelectORA(TK_TIPOS_ACAO_SELECAO_SERVICO.PESQUISA, item.sagService);
      launch(item);
    }
  }

  return <InfoScreen
    icon={telaSucesso}
    action={action}
    buttonText={buttonText}
    primaryText={MSG_DOCUMENTO_BAIXADO_SUCESSO}
    secondaryText={blankMessage ? '' : MSG_AGENDAR_ATENDIMENTO_PRESENCIAL}
    servico={servico}
    descricao={descricao}
  />

}

const mapStateToProps = state => ({
  menuItems: state.app.menuItems
});

export const DownloadSuccessScreen = connect(mapStateToProps)(DownloadSuccessScreen_);

const useStyles = makeStyles(theme => ({
  menu_item: {
    fontSize: '0.9rem',
  },
  container: {
    flexDirection: 'column',
    display: 'flex',
    textAlign: 'left',
    margin: 'auto',
    color: theme.shared.template.InfoScreen.primaryText.color,
    [theme.breakpoints.up('xs')]: {
      padding: '0px 20px 10px 20px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '5px 20px 5px 20px',
    },
    fontWeight: '600',
    alignItems: 'center'

  },
  containerFooter: {
    flexDirection: 'column',
    display: 'flex',
    textAlign: 'left',
    color: theme.shared.template.InfoScreen.primaryText.color,
    [theme.breakpoints.up('xs')]: {
      padding: '5px 20px 10px 20px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '5px 20px 10px 20px',
    },
    fontWeight: '600',
    alignItems: 'center',
  },
  containerFooterDivergente: {
    flexDirection: 'column',
    display: 'flex',
    textAlign: 'left',
    color: theme.shared.template.InfoScreen.primaryText.color,
    [theme.breakpoints.up('xs')]: {
      padding: '5px 0px 10px 20px',
    },
    [theme.breakpoints.up('md')]: {
      padding: '5px 0px 10px 20px',
    },
    fontWeight: '600',
    alignItems: 'center',
  },
  img: {
    width: '150px',
    margin: 'auto',
  },
  primaryText: {
    marginBottom: theme.spacing(5),
    fontSize: '1.2em',
    fontWeight: '600',
    color: theme.shared.template.InfoScreen.primaryText.color,
    maxWidth: '32.3125rem!important'
  },
  secondaryText: {
    fontSize: '1.1em',
    wordWrap: 'break-word',
    color: theme.shared.template.InfoScreen.secondaryText.color,
    maxWidth: '21.375rem !important',
    fontWeight: 'normal !important',
    '& a': {
      fontSize: '1.1em',
      wordWrap: 'break-word',
      fontWeight: 'normal !important',
    }
  },
  infoContainer: {
    display: 'flex',
    [theme.breakpoints.up('xs')]: {
      flexDirection: 'column',
      padding: '5px 20px 5px 20px',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      padding: '5px 20px 5px 20px',
    },
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
    fontWeight: '600',
  },
  infoContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
  },
  primaryTextLateral: {
    fontWeight: '600',
    [theme.breakpoints.up('xs')]: {
      textAlign: 'center',
      marginBottom: '8px',
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
    color: theme.shared.template.InfoScreen.primaryText.color,
  },
  secondaryTextLateral: {
    color: theme.shared.template.InfoScreen.secondaryText.color,
    [theme.breakpoints.up('xs')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
    fontWeight: 'normal !important',
  },
  item: {
    margin: '5px',
    padding: '0 5px',
    maxWidth: '780px',
  },
  itemContent: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('xs')]: {
      alignItems: 'center',
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
      alignItems: 'flex-start',
    },
    minHeight: '120px',
  },
  hr2: {
    border: '0',
    borderTop: '1px dashed #CCC',
    width: '100%',
  },
  btn: {
    margin: 'auto',
  },
  AppFooter: {
    width: '100%',
    display: 'flex',
    [theme.breakpoints.up('xs')]: {
      justifyContent: 'center',
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
    },
  },
}));